import { Route } from '@modules/husleie-framework/src/types/Route.entity';
import type { AppRoutesState, AppRouteExitData } from '@modules/store/common/types/AppRoutesState.entity';
import type CommonState from '@modules/store/common/types/CommonState.entity';
import { GetterTree } from 'vuex';

export const getters: GetterTree<AppRoutesState, CommonState> = {
  getInitialRoutes(state: AppRoutesState): Route[] {
    return state.initialRoutes;
  },
  getActiveRoutes(state: AppRoutesState): Route[] {
    const activeRoutes: Route[] = state.initialRoutes.filter((route: Route) => !route.hidden);
    return activeRoutes.map((route, index) => {
      return { ...route, index };
    });
  },
  getVisibleRoutes(state: AppRoutesState, getters): Route[] {
    const currentIndex = getters.getCurrentActiveRouteIndex;
    let startIndex: number =
      state.numberOfVisibleRoutesAllowed !== undefined
        ? state.numberOfVisibleRoutesAllowed! > 2
          ? Math.max(currentIndex - 1, 0)
          : currentIndex
        : 0;
    const endIndex: number =
      state.numberOfVisibleRoutesAllowed !== undefined
        ? Math.min(startIndex + state.numberOfVisibleRoutesAllowed!, getters.getNumberOfActiveRoutes)
        : getters.getNumberOfActiveRoutes;

    if (state.numberOfVisibleRoutesAllowed && endIndex - startIndex < state.numberOfVisibleRoutesAllowed) {
      startIndex = Math.max(endIndex - state.numberOfVisibleRoutesAllowed, 0);
    }

    return getters.getActiveRoutes.slice(startIndex, endIndex);
  },
  getNumberOfActiveRoutes(state: AppRoutesState, getters): number {
    return getters.getActiveRoutes.length;
  },
  getNumberOfVisibleRoutes(state: AppRoutesState): undefined | number {
    return state.numberOfVisibleRoutesAllowed;
  },
  getCurrentActiveRouteIndex(state: AppRoutesState): number {
    return state.currentRouteIndex;
  },
  hideProgressBar(state: AppRoutesState): boolean {
    return !!state.hideProgressBar;
  },
  getExitRouteData(state: AppRoutesState): AppRouteExitData {
    return state.exit;
  },
};
